import * as React from "react";
import { AnalyticsStore } from "bernie-core";
import { useLocalization } from "@shared-ui/localization-context";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutConditionalGridColumnRow,
  UitkLayoutConditionalGridSpan,
} from "uitk-react-layout-grid";
import { UitkHeading } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { HotelWizardState } from "stores/wizard/state";
import { HotelAddFlightCheckbox } from "./HotelAddFlightCheckbox";
import { HotelAddCarCheckbox } from "./HotelAddCarCheckbox";

interface WizardFlightAndCarOptionsProps {
  mainGridColumns: UitkLayoutConditionalGridColumnRow;
  addFlightColSpan: UitkLayoutConditionalGridSpan;
  addCarColSpan: UitkLayoutConditionalGridSpan;
  hotelWizardState: HotelWizardState;
  onAddFlightCheckboxChange: () => void;
  analytics?: AnalyticsStore;
  shouldNotDisplay?: boolean;
}

export const WizardFlightAndCarOptions: React.FC<WizardFlightAndCarOptionsProps> = ({
  mainGridColumns,
  addFlightColSpan,
  addCarColSpan,
  hotelWizardState,
  onAddFlightCheckboxChange,
  analytics,
  shouldNotDisplay,
}) => {
  const { formatText } = useLocalization();

  return (
    <div className={shouldNotDisplay ? "is-hidden" : ""}>
      <UitkSpacing padding={{ blockstart: "six" }}>
        <UitkHeading tag="h5" size={5}>
          {formatText("wizard.packages.options.flightAndCar.title")}
        </UitkHeading>
      </UitkSpacing>
      <UitkSpacing margin={{ blockstart: "two" }}>
        <UitkLayoutGrid columns={mainGridColumns}>
          <UitkLayoutGridItem colSpan={addFlightColSpan}>
            <div>
              <HotelAddFlightCheckbox
                hotelWizardState={hotelWizardState}
                onChange={onAddFlightCheckboxChange}
                analytics={analytics}
              />
            </div>
          </UitkLayoutGridItem>
          <UitkLayoutGridItem colSpan={addCarColSpan}>
            <div>
              <HotelAddCarCheckbox hotelWizardState={hotelWizardState} analytics={analytics} />
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </UitkSpacing>
    </div>
  );
};
